export const cpfMask = (inputValue: string) => {
  inputValue = inputValue.replace(/\D/g, "");

  const cpfSubstringsList = inputValue.split("");
  const formattedCpf = cpfSubstringsList.slice(0, 11);
  const size = formattedCpf.length;

  if (size > 9) {
    return formattedCpf
      .join("")
      .replace(/^(\d{3})(\d{3})(\d{3})(\d{1,})$/g, "$1.$2.$3-$4");
  } else if (size > 6) {
    return formattedCpf
      .join("")
      .replace(/^(\d{3})(\d{3})(\d{1,})$/g, "$1.$2.$3");
  } else if (size > 3) {
    return formattedCpf.join("").replace(/^(\d{3})(\d{1,})$/g, "$1.$2");
  } else {
    return formattedCpf.join("");
  }
};

export const dateMask = (inputValue: string) => {
  inputValue = inputValue.replace(/\D/g, "");

  const inputValueSubstrings = inputValue.split("");
  const formattedDate = inputValueSubstrings.slice(0, 8);
  const size = formattedDate.length;

  if (size > 4) {
    return formattedDate
      .join("")
      .replace(/^(\d{2})(\d{2})(\d{1,})$/g, "$1/$2/$3");
  } else if (size > 2) {
    return formattedDate.join("").replace(/^(\d{2})(\d{1,})$/g, "$1/$2");
  } else {
    return formattedDate.join("");
  }
};

export const phoneMask = (inputValue: string) => {
  inputValue = inputValue.replace(/\D/g, "");

  const inputValueSubstrings = inputValue.split("");
  const formattedPhone = inputValueSubstrings.slice(0, 11);
  const size = formattedPhone.length;

  if (size > 7) {
    if (size === 10) {
      return formattedPhone
        .join("")
        .replace(/^(\d{2})(\d{4})(\d{1,})$/g, "($1) $2-$3");
    }
    return formattedPhone
      .join("")
      .replace(/^(\d{2})(\d{5})(\d{1,})$/g, "($1) $2-$3");
  } else if (size > 2) {
    return formattedPhone.join("").replace(/^(\d{2})(\d{1,})$/g, "($1) $2");
  } else {
    return formattedPhone.join("");
  }
};

export const cepMask = (inputValue: string) => {
  inputValue = inputValue.replace(/\D/g, "");

  const inputValueSubstrings = inputValue.split("");
  const formattedCep = inputValueSubstrings.slice(0, 8);
  const size = formattedCep.length;

  if (size > 5) {
    return formattedCep.join("").replace(/^(\d{5})(\d{1,})$/g, "$1-$2");
  } else {
    return formattedCep.join("");
  }
};
